export const EVM_SUPPORTED_CHAINS = ["ethereum", "avalanche", "polygon"];
export const EVM_SUPPORTED_WALLETS = [
  "metamask",
  "exodus",
  "trust-wallet",
  "coin98",
];
